import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  TAG_SUBTOPICS: 'TAG_SUBTOPICS',
  TAG_SUBTOPICS_SUCCESS: 'TAG_SUBTOPICS_SUCCESS',
  TAG_SUBTOPICS_FAILED: 'TAG_SUBTOPICS_FAILED',

  GET_TAGGABLE_SUBTOPCIS: 'GET_TAGGABLE_SUBTOPCIS',
  GET_TAGGABLE_SUBTOPCIS_SUCCESS: 'GET_TAGGABLE_SUBTOPCIS_SUCCESS',
  GET_TAGGABLE_SUBTOPCIS_FAILED: 'GET_TAGGABLE_SUBTOPCIS_FAILED',

  RESET_LOADING_STATUS: 'RESET_LOADING_STATUS',
};

export const getTaggableSubtopics = () => ({
  type: types.GET_TAGGABLE_SUBTOPCIS,
});

export const getTaggableSubtopicsSuccess = (subtopics) => ({
  type: types.GET_TAGGABLE_SUBTOPCIS_SUCCESS,
  payload: {
    subtopics,
  },
});

export const getTaggableSubtopicsFailed = (errorMessage) => ({
  type: types.GET_TAGGABLE_SUBTOPCIS_FAILED,
  payload: {
    errorMessage,
  },
});

export const tagSubtopics = (subtopicIds) => ({
  type: types.TAG_SUBTOPICS,
  payload: {
    subtopicIds,
  },
});

export const tagSubtopicsSuccess = () => ({
  type: types.TAG_SUBTOPICS_SUCCESS,
});

export const tagSubtopicsFailed = (errorMessage) => ({
  type: types.TAG_SUBTOPICS_FAILED,
  payload: {
    errorMessage,
  },
});

export const resetLoadingStatus = () => ({
  type: types.RESET_LOADING_STATUS,
});

const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
  updateTaggingStatus: loadingState.EMPTY, // this is for special UI behavior.
  taggableSubtopics: [],
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case types.GET_TAGGABLE_SUBTOPCIS:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case types.GET_TAGGABLE_SUBTOPCIS_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        taggableSubtopics: action.payload.subtopics,
      };
    case types.GET_TAGGABLE_SUBTOPCIS_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
      };
    case types.TAG_SUBTOPICS:
      return {
        ...state,
        updateTaggingStatus: loadingState.LOADING,
      };
    case types.TAG_SUBTOPICS_SUCCESS:
      return {
        ...state,
        updateTaggingStatus: loadingState.READY,
      };
    case types.TAG_SUBTOPICS_FAILED:
      return {
        ...state,
        updateTaggingStatus: loadingState.ERROR,
      };
    case types.RESET_LOADING_STATUS:
      return {
        ...state,
        updateTaggingStatus: loadingState.EMPTY,
      };
    default:
      return state;
  }
}

export const getLoadingStatus = (state) => state.chat.tagging.loadingStatus;
export const getUpdateTaggingStatus = (state) =>
  state.chat.tagging.updateTaggingStatus;
export const getTaggableSubtopicList = (state) =>
  state.chat.tagging.taggableSubtopics;
export const getHasTagged = (state) =>
  state.chat.tagging.taggableSubtopics.filter((t) => t.is_tagged).length !== 0;
export const getTaggedSubtopics = (state) =>
  state.chat.tagging.taggableSubtopics.filter((t) => t.is_tagged) || [];



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/tagging.js